import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const PipelineDevPage = () => {
  return <TechnicalServicePage serviceKey="pipelineDev" />
}

export default PipelineDevPage
